import { TermProgramInfoModel } from '../../term_courses/models/term_program_info_model';
import { RegistrationTransactionsQuery } from '../queries/registration_transactions_query';
import * as _4 from 'lodash4';
import { RequestActionServant } from '../servants/request_action_servant';

export class RegistrationTransactions {
  private termName = '';
  constructor(
    private ngTermProgramInfoModel: TermProgramInfoModel,
    private $state: ng.ui.IStateService,
    private $window: ng.IWindowService,
    private ngRegistrationTransactionsQuery: RegistrationTransactionsQuery,
    private ngRequestActionServant: RequestActionServant
  ) {}
  $onChanges() {
    this.init();
  }
  init() {
    this.termName = _4.get(this.ngTermProgramInfoModel.read(), 'term.name', '');
  }
  print() {
    this.$window.print();
  }

  hasTransactions() {
    return !_4.isEmpty(this.ngRegistrationTransactionsQuery.result.transactions);
  }

  gotoRegistration() {
    this.$state.go('my.schedule.registration');
  }
}

class RegistrationTransactionsComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.controller = RegistrationTransactions;
    this.bindings = {};
    this.templateUrl =
      'capability-ng-scheduler/src/views/registration_transactions/components/registration_transactions.html';
  }
}
angular
  .module('capability-ng-scheduler')
  .component('registrationTransactions', new RegistrationTransactionsComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration_transactions/components/registration_transactions.ts